import { useNavigate } from 'react-router-dom';
import { PermissionGuard } from '@/features/auth';
import { Button } from '@/shared/components';
import { useConfirmedAction } from '../hooks/useConfirmedAction';
import { useDeleteTemplateMutation } from '../hooks/useTemplateMutations';
import { TemplateActionConfirm } from './TemplateActionConfirm';

interface Props {
  templateId: string;
  templateName: string;
}

export function DeleteTemplateAction({ templateId, templateName }: Props) {
  const navigate = useNavigate();
  const remove = useConfirmedAction(useDeleteTemplateMutation(templateId), () =>
    navigate('/admin/document-templates'),
  );

  return (
    <PermissionGuard permission={{ resource: 'document_template', action: 'delete' }}>
      <Button type="button" variant="danger" size="sm" onClick={remove.open}>
        Delete template
      </Button>
      <TemplateActionConfirm
        isOpen={remove.isOpen}
        title="Delete this template?"
        message={`"${templateName}" will be deleted. Its version history stays readable, but it can no longer be used to generate documents.`}
        confirmLabel="Delete template"
        isPending={remove.isPending}
        error={remove.error}
        onConfirm={() => remove.confirm()}
        onClose={remove.close}
      />
    </PermissionGuard>
  );
}
